export const isMeetinOpenUtil = (meetingDetails, meetingOpen) => {
  if (meetingOpen !== undefined) {
    return meetingOpen;
  } else if (
    meetingDetails &&
    meetingDetails.VirtualMeeting &&
    meetingDetails.VirtualMeeting.CompanyMeeting
  ) {
    return meetingDetails.VirtualMeeting.CompanyMeeting.MeetingOpen;
  }
  return false;
};
